module.exports = __webpack_public_path__ + "static/img/logo.daffcaef.png";